
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/pharmaceutical-development",
      function () {
        return require("private-next-pages/about-us/pharmaceutical-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/pharmaceutical-development"])
      });
    }
  